import { types } from "../../types/types";

const initialState = {
  cargada: false,
  items: [],
  loading: false,
  error: null,
};
export const documentacionAfiliacionReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case types.documentacionTraerCargadaStart:
      return {
        ...state,
        loading: true,
        error: null,
        cargada: false,
      };
    case types.documentacionTraerCargadaSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload,
        cargada: true,
      };
    case types.documentacionTraerCargadaError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        items: [],
        cargada: false,
      };
    case types.documentacionLimpiarLista:
      return {
        loading: false,
        error: null,
        items: [],
        cargada: false,
      };
    case types.documentacionSubidaSuccess:
      return {
        ...state,
        loading: false,
        cargada: true,
        items: [action.payload, ...state.items],
      };
    case types.documentacionUpdated:
      return {
        ...state,
        cargada: true,
        items: state.items.map((item) =>
          item.idDocumentacionAfiliado ===
          action.payload.idDocumentacionAfiliado
            ? {
                ...item,
                idTipoDocumentaciones: action.payload.idTipoDocumentaciones,
              }
            : item
        ),
      };
    case types.documentacionDelete:
      return {
        ...state,
        cargada: true,
        items: state.items.filter(
          (item) => parseInt(item.idDocumentacionAfiliado) !== parseInt(action.payload)
        ),
      };
    case types.documentacionStartUpdate:
      return {
        ...state,
        cargada: false,
        error: null,
      };
    default:
      return state;
  }
};
